import Vue from 'vue';
import Router, { NavigationGuard } from 'vue-router';
import { tokenModule } from '@/store/authentication/authentication';
import { loginModule } from '@/store/authentication/login';
import { トークン型 } from '@/type/authentication/authentication';
import {ログインアカウント型} from '@/type/authentication/login';

Vue.use(Router);

const progosspd: string | null = sessionStorage.getItem('progosspd');

if (progosspd) {
  const token: トークン型 = JSON.parse(progosspd).token.トークン;
  tokenModule.トークンを戻す(token);
}


const guards: NavigationGuard<Vue> = (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!tokenModule.認証されている) {
      next({ name: 'logon' });
      return;
    }
  }
  const storage: string | null = sessionStorage.getItem('progosspd');
  if (storage) {
    const account: ログインアカウント型 = JSON.parse(storage).login.ログインアカウント;
    if (account) {
      loginModule.ログインアカウントを戻す(account);
    }
  }
  if (to.matched.some((record) => record.meta.transferMedical)) {
    if (!loginModule.譲渡譲受を利用する) {
      next({ name: 'notFound' });
      return;
    }
  }
  if (to.matched.some((record) => record.meta.externalCooperation)) {
    if (!loginModule.外部連携を利用する) {
      next({ name: 'notFound' });
      return;
    }
  }
  next();
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/manager/:token',
      name: 'manager',
      component: () => import('@/views/Manager.vue'),
      meta: { requiresAuth: false },
      props: true,
    },
    {
      path: '/logon',
      name: 'logon',
      component: () => import('@/views/Logon.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: { title: 'メニュー', requiresAuth: true },
    },
    {
      path: '/purchaseorder',
      name: '発注',
      component: () => import('@/views/purchaseorder/RegisterOrder.vue'),
      meta: { title: '発注', requiresAuth: true },
    },
    {
      path: '/purchaseorder/history',
      name: '発注履歴照会',
      component: () => import('@/views/purchaseorder/ListPurchaseOrderHistories.vue'),
      meta: { title: '発注履歴照会', requiresAuth: true },
    },
    {
      path: '/purchaseorder/report',
      name: '発注書印刷',
      component: () => import('@/views/purchaseorder/PrintPurchaseOrder.vue'),
      meta: { title: '発注書印刷', requiresAuth: true },
    },
    {
      path: '/purchaseorder/report/confirmation',
      name: '発注確認書',
      component: () => import('@/views/purchaseorder/PrintOrderConfirmation.vue'),
      meta: { title: '発注確認書', requiresAuth: true },
    },
    {
      path: '/purchaseorder/status',
      name: '発注状況修正',
      component: () => import('@/views/purchaseorder/ListPurchaseOrderStatuses.vue'),
      meta: { title: '発注状況修正', requiresAuth: true },
    },
    {
      path: '/stock/unfixed',
      name: '入庫',
      component: () => import('@/views/stock/receive/UnfixedStock.vue'),
      meta: { title: '入庫', requiresAuth: true },
    },
    {
        path: '/stock/fixed',
        name: '入庫修正・削除',
        component: () => import('@/views/stock/receive/FixedStock.vue'),
        meta: { title: '入庫修正・削除', requiresAuth: true },
    },
    {
      path: '/stock/receive/history',
      name: '入庫履歴照会',
      component: () => import('@/views/stock/receive/ListStockReceiveHistories.vue'),
      meta: { title: '入庫履歴照会', requiresAuth: true },
  },
  {
    path: '/stock/receive/price_diff',
    name: '入庫返品薬価差照会',
    component: () => import('@/views/stock/receive/ListStockReceivePriceDiff.vue'),
    meta: { title: '入庫返品薬価差照会', requiresAuth: true },
  },
  {
      path: '/stock/returns/unfixed',
      name: '返品',
      component: () => import('@/views/stock/returns/UnfixedReturnStock.vue'),
      meta: { title: '返品', requiresAuth: true },
    },
    {
      path: '/stock/returns/history',
      name: '返品履歴照会',
      component: () => import('@/views/stock/returns/ListStockReturnsHistories.vue'),
      meta: { title: '返品履歴照会', requiresAuth: true },
  },
    {
      path: '/stock/returns/fixed',
      name: '返品修正・削除',
      component: () => import('@/views/stock/returns/FixedReturnStock.vue'),
      meta: { title: '返品修正・削除', requiresAuth: true },
    },
    {
      path: '/stock/unstocked_deliverydata',
      name: '納品データ未入庫照会',
      component: () => import('@/views/stock/deliverydata/ListUnstockedDeliveryData.vue'),
      meta: { title: '納品データ未入庫照会', requiresAuth: true },
    },
    {
      path: '/stock/deliverydata',
      name: '納品データ受信確認',
      component: () => import('@/views/stock/deliverydata/ListDeliveryData.vue'),
      meta: { title: '納品データ受信確認', requiresAuth: true },
    },
    {
      path: '/stock/summary/receive_delivery',
      name: '卸別入出庫集計照会',
      component: () => import('@/views/stock/summary/ListReceiveDeliverySummaries.vue'),
      meta: { title: '卸別入出庫集計照会', requiresAuth: true },
    },
    {
      path: '/stock/inherit/input',
      name: '譲受',
      component: () => import('@/views/stock/inherit/InheritInput.vue'),
      meta: { title: '譲受', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/stock/inherit/modify',
      name: '譲受修正・削除',
      component: () => import('@/views/stock/inherit/InheritModification.vue'),
      meta: { title: '譲受修正・削除', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/stock/inherit/history',
      name: '譲受履歴照会',
      component: () => import('@/views/stock/inherit/ListInheritHistories.vue'),
      meta: { title: '譲受履歴照会', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/withdrawal/input',
      name: '払出',
      component: () => import('@/views/withdrawal/WithdrawalInput.vue'),
      meta: { title: '払出', requiresAuth: true },
    },
    {
      path: '/withdrawal/modify',
      name: '払出修正・削除',
      component: () => import('@/views/withdrawal/WithdrawalModification.vue'),
      meta: { title: '払出修正・削除', requiresAuth: true },
    },
    {
      path: '/withdrawal/reference',
      name: '払出履歴照会',
      component: () => import('@/views/withdrawal/ReferenceWithdrawal.vue'),
      meta: { title: '払出履歴照会', requiresAuth: true },
    },
    {
      path: '/destroy/input',
      name: '破棄破損',
      component: () => import('@/views/destroy/DestroyInput.vue'),
      meta: { title: '破棄破損', requiresAuth: true },
    },
    {
      path: '/destroy/modify',
      name: '破棄破損修正・削除',
      component: () => import('@/views/destroy/DestroyModification.vue'),
      meta: { title: '破棄破損修正・削除', requiresAuth: true },
    },
    {
      path: '/destroy/reference',
      name: '破棄破損履歴照会',
      component: () => import('@/views/destroy/ReferenceDestroy.vue'),
      meta: { title: '破棄破損履歴照会', requiresAuth: true },
    },
    {
      path: '/stock/devolve/input',
      name: '譲渡',
      component: () => import('@/views/stock/devolve/DevolveInput.vue'),
      meta: { title: '譲渡', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/stock/devolve/modification',
      name: '譲渡修正・削除',
      component: () => import('@/views/stock/devolve/DevolveModification.vue'),
      meta: { title: '譲渡修正・削除', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/stock/devolve/history',
      name: '譲渡履歴照会',
      component: () => import('@/views/stock/devolve/ListDevolveHistories.vue'),
      meta: { title: '譲渡履歴照会', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/refstock',
      name: '在庫照会',
      component: () => import('@/views/refstock/ReferenceStock.vue'),
      meta: { title: '在庫照会', requiresAuth: true },
    },
    {
      path: '/stock/itemledger',
      name: '商品台帳照会',
      component: () => import('@/views/stock/itemledger/ItemLedger.vue'),
      meta: { title: '商品台帳照会', requiresAuth: true },
    },
    {
      path: '/stock/interim',
      name: '経過措置照会',
      component: () => import('@/views/stock/interim/InterimReference.vue'),
      meta: { title: '経過措置照会', requiresAuth: true },
    },
    {
      path: '/inactive/stock',
      name: '不動在庫照会',
      component: () => import('@/views/inactive/ListInactiveStock.vue'),
      meta: { title: '不動在庫照会', requiresAuth: true },
    },
    {
      path: '/stock/inhospital',
      name: '院内総在庫照会',
      component: () => import('@/views/stock/inhospital/InHospitalStock.vue'),
      meta: { title: '院内総在庫照会', requiresAuth: true },
    },
    {
      path: '/stock/receiveandreturns',
      name: '入出庫照会',
      component: () => import('@/views/stock/receiveandreturns/ReceiveAndReturns.vue'),
      meta: { title: '入出庫照会', requiresAuth: true },
    },
    {
      path: '/master/item',
      name: '採用品マスタ',
      component: () => import('@/views/master/ListItems.vue'),
      meta: { title: '採用品マスタ', requiresAuth: true },
    },
    {
      path: '/master/item/external',
      name: '外部連携商品設定',
      component: () => import('@/views/master/ExternalCooperation.vue'),
      meta: { title: '外部連携商品設定', requiresAuth: true , externalCooperation: true},
    },
    {
      path: '/master/item/import',
      name: '採用品一括更新',
      component: () => import('@/views/master/ImportItem.vue'),
      meta: { title: '採用品一括更新', requiresAuth: true },
    },
    {
      path: '/master/wholesale',
      name: '卸マスタ',
      component: () => import('@/views/wholesale/ListWholesales.vue'),
      meta: { title: '卸マスタ', requiresAuth: true },
    },
    {
      path: '/master/department',
      name: '部署マスタ',
      component: () => import('@/views/department/ListDepartments.vue'),
      meta: { title: '部署マスタ', requiresAuth: true },
    },
    {
      path: '/master/user',
      name: 'ログインマスタ',
      component: () => import('@/views/user/ListUsers.vue'),
      meta: { title: 'ログインマスタ', requiresAuth: true },
    },
    {
      path: '/master/shelf',
      name: '棚番設定',
      component: () => import('@/views/shelf/ShelfSettings.vue'),
      meta: { title: '棚番設定', requiresAuth: true },
    },
    {
      path: '/master/stock/immovable',
      name: '不動日数設定',
      component: () => import('@/views/stock/immovable/ImmovableDaysModification.vue'),
      meta: { title: '不動日数設定', requiresAuth: true },
    },
    {
      path: '/master/transfermedical',
      name: '譲渡・譲受医療機関マスタ',
      component: () => import('@/views/transfermedical/ListTransferMedicals.vue'),
      meta: { title: '譲渡・譲受医療機関マスタ', requiresAuth: true, transferMedical: true },
    },
    {
      path: '/stocktaking/register',
      name: '棚卸',
      component: () => import('@/views/stocktaking/RegisterStocktaking.vue'),
      meta: { title: '棚卸', requiresAuth: true },
    },
    {
      path: '/stocktaking/cancel',
      name: '棚卸確定取消',
      component: () => import('@/views/stocktaking/CancelStocktaking.vue'),
      meta: { title: '棚卸確定取消', requiresAuth: true },
    },
    {
      path: '/inquire/inventory_diff',
      name: '棚卸差数照会',
      component: () => import('@/views/inquire/InventoryDiff.vue'),
      meta: { title: '棚卸差数照会', requiresAuth: true },
    },
    {
      path: '/estimates/comparison',
      name: '卸比較',
      component: () => import('@/views/estimates/Comparison.vue'),
      meta: { title: '卸比較', requiresAuth: true },
    },
    {
      path: '/estimates/retrospective',
      name: '価格登録遡及訂正',
      component: () => import('@/views/retrospective/Retrospective.vue'),
      meta: { title: '価格登録遡及訂正', requiresAuth: true },
    },
    {
      path: '/estimates/retrospective/reserve',
      name: '遡及価格更新',
      component: () => import('@/views/retrospective/ListRetrospectiveReserves.vue'),
      meta: { title: '遡及価格更新', requiresAuth: true },
    },
    {
      path: '/automatedorder/config',
      name: '定点発注条件設定',
      component: () => import('@/views/automatedorder/RegisterReorderPointItems.vue'),
      meta: { title: '定点発注条件設定', requiresAuth: true },
    },
    {
      path: '/movement/RegisterMovement',
      name: '移動',
      component: () => import('@/views/movement/RegisterMovement.vue'),
      meta: { title: '部署間移動', requiresAuth: true },
    },
    {
      path: '/movement/FixedMovement',
      name: '移動修正・削除',
      component: () => import('@/views/movement/FixedMovement.vue'),
      meta: { title: '部署間移動修正・削除', requiresAuth: true },
    },
    {
      path: '/movement/ReferenceMovement',
      name: '移動履歴照会',
      component: () => import('@/views/movement/ReferenceMovement.vue'),
      meta: { title: '部署間移動履歴照会', requiresAuth: true },
    },
    {
      path: '/aggregate/withdraw',
      name: '払出一覧',
      component: () => import('@/views/custom/sapporoshirakabadai/withdraw/AggregateWithdraw.vue'),
      meta: { title: '払出一覧', requiresAuth: true },
    },
    {
      path: '/aggregate/stock',
      name: '在庫集計表',
      component: () => import('@/views/custom/keiaikai/stock/AggregateStock.vue'),
      meta: { title: '在庫集計表', requiresAuth: true },
    },
    {
      path: '/delivery/weighted',
      name: '納品加重明細表',
      component: () => import('@/views/custom/teishinkai/DeliveryWeightedDetail.vue'),
      meta: { title: '納品加重明細表', requiresAuth: true },
    },
    {
      path: '/report/print/barcodebook',
      name: 'バーコードブック印刷',
      component: () => import('@/views/barcodebook/PrintBarcodeBook.vue'),
      meta: { title: 'バーコードブック印刷', requiresAuth: true },
    },
    {
      path: '/external/capture',
      name: '外部連携取込',
      component: () => import('@/views/external/ExternalCapture.vue'),
      meta: { title: '外部連携取込', requiresAuth: true, externalCooperation: true },
    },
    {
      path: '/external/capture/list',
      name: '外部連携取込履歴',
      component: () => import('@/views/external/ExternalCaptureList.vue'),
      meta: {title: '外部連携取込履歴', requiresAuth: true, externalCooperation: true},
    },
    {
      path: '/external/move/list',
      name: '外部連携移動履歴',
      component: () => import('@/views/external/ExternalMoveHistoryList.vue'),
      meta: {title: '外部連携移動履歴照会', requiresAuth: true, externalCooperation: true},
    },
    {
      path: '/adjustment/RegisterAdjustment',
      name: '在庫調整',
      component: () => import('@/views/adjustment/RegisterAdjustment.vue'),
      meta: { title: '旧JAN在庫調整', requiresAuth: true },
    },
    {
      path: '/item/price/',
      name: '価格一括更新',
      component: () => import('@/views/item/ListItemPrices.vue'),
      meta: { title: '価格一括更新', requiresAuth: true },
    },
    {
      path: '/wholesale/primary/',
      name: '卸一括更新',
      component: () => import('@/views/wholesale/ListPrimaryWholesales.vue'),
      meta: { title: '卸一括更新', requiresAuth: true },
    },
    {
      path: '/manual/file',
      name: 'マニュアルダウンロード',
      component: () => import('@/views/manual/ManualList.vue'),
      meta: { title: 'マニュアルダウンロード', requiresAuth: true },
    },
    {
      path: '/medical/group',
      name: '医療機関グループ参照',
      component: () => import('@/views/medical/ReferenceMedicalGroup.vue'),
      meta: { title: '医療機関グループ参照', requiresAuth: true },
    },
    {
      path: '/share/inactive-stock',
      name: 'グループ在庫共有',
      component: () => import('@/views/share/GroupStockSharing.vue'),
      meta: { title: 'グループ在庫共有', requiresAuth: true },
    },
    {
      path: '/custom/keijinkai/deliverydataoutput',
      name: '納品データ出力',
      component: () => import('@/views/custom/keijinkai/DeliveryDataOutput.vue'),
      meta: { title: '納品データ出力', requiresAuth: true },
    },
    {
      path: '/custom/keijinkai/totalstock',
      name: '部署別在庫集計表',
      component: () => import('@/views/custom/keijinkai/TotalStockByDepartment.vue'),
      meta: { title: '部署別在庫集計表', requiresAuth: true },
    },
    {
      path: '/custom/otaru/destroy',
      name: '期限切れ・破棄破損',
      component: () => import('@/views/custom/otaru/destroy/OtaruDestroyList.vue'),
      meta: {title: '期限切れ／破棄破損', requiresAuth: true},
    },
    {
      path: '/custom/keijinkai/receiveandreturns',
      name: '入出庫集計表',
      component: () => import('@/views/custom/keijinkai/ReceiveAndReturns.vue'),
      meta: { title: '入出庫集計表', requiresAuth: true },

    },
    {
      path: '/custom/keijinkai/shipment',
      name: '部署別出庫実績集計表',
      component: () => import('@/views/custom/keijinkai/ShipmentByDepartment.vue'),
      meta: { title: '部署別出庫実績集計表', requiresAuth: true },
    },
    {
      path: '/otaru/report/reportmenu',
      name: '小樽市立病院個別帳票出力画面',
      component: () => import('@/views/custom/otaru/report/ReportMenu.vue'),
      meta: { title: '小樽市立病院個別帳票出力画面', requiresAuth: true },
    },
    {
      path: '/custom/goryoukaku/shelf',
      name: '函館五稜郭病院棚番設定画面',
      component: () => import('@/views/custom/goryoukaku/GoryoukakuShelfSettings.vue'),
      meta: { title: '棚番設定', requiresAuth: true },
    },
    {
      path: '/custom/goryoukaku/report',
      name: '函館五稜郭病院個別帳票出力画面',
      component: () => import('@/views/custom/goryoukaku/GoryoukakuReportOutput.vue'),
      meta: { title: '個別帳票出力画面', requiresAuth: true },
    },
    {
      path: '/otaru/tosho/recieve/detail',
      name: '小樽市立病院トーショー納入明細出力画面',
      component: () => import('@/views/custom/otaru/tosho/RecieveDetail.vue'),
      meta: { title: '小樽市立病院トーショー納入明細出力画面', requiresAuth: true },
    },
    {
      path: '/shinsapporo/report/reportmenu',
      name: '新さっぽろ脳神経外科病院個別帳票出力画面',
      component: () => import('@/views/custom/shinsapporo/report/ReportMenu.vue'),
      meta: { title: '新さっぽろ脳神経外科病院個別帳票出力画面', requiresAuth: true },
    },
    {
      path: '/expire',
      name: 'expire',
      component: () => import('@/views/Expire.vue'),
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/Maintenance.vue'),
    },
    {
      path: '/systemerror',
      name: 'systemerror',
      component: () => import('@/views/SystemError.vue'),
    },
    {
      path: '*',
      name: 'notFound',
      component: () => import('@/views/NotFound.vue'),
    },
  ],
});

router.beforeEach(guards);

export default router;
